import { BILLING_INTERVAL, PLAN_INTERVAL } from "@/data/constants";
import { TBillingInterval, TPlanCurrentInterval } from "@/types/app";
import { MONTHS_PER_INTERVAL } from "@/utils/billingInterval";

// Maps a subscription's recurring shape onto a billing interval: Stripe bills
// half_yearly as monthly with an `interval_count` of 6.
export const formatBillingInterval = (
  recurringInterval: TPlanCurrentInterval,
  intervalCount = 1,
): TBillingInterval => {
  if (recurringInterval === PLAN_INTERVAL.MONTH) {
    return intervalCount === MONTHS_PER_INTERVAL[BILLING_INTERVAL.HALF_YEARLY]
      ? BILLING_INTERVAL.HALF_YEARLY
      : BILLING_INTERVAL.MONTHLY;
  }

  return BILLING_INTERVAL.YEARLY;
};

export default formatBillingInterval;
